import useTranslation from 'next-translate/useTranslation';
import useKeyboardInteractions from 'src/hooks/useKeyboardInteractions';
import { MEDIA_TYPE, NAVIGATION_KEYS, TRANSMISSION_TYPE } from 'src/interfaces/enums';
import SettingOption from 'src/themes/cosmos/components/SettingOption';
import { ChevronRightIcon } from 'src/themes/cosmos/icons';
import useMenuRoute from 'src/themes/shared/containers/MenuRouteContainer/hooks/useMenuRoute';
import SettingOptionLabel from 'src/themes/cosmos/components/SettingOptionLabel';
import usePlayback from 'src/hooks/usePlayback';
import useResolution from 'src/hooks/useResolution';
import useApplicationData from 'src/hooks/useApplicationData';
import { MENU_ROUTES } from '../../routes';

const HomeSettingControlContainer = () => {
  const { t } = useTranslation('common');
  const { push } = useMenuRoute();
  const { playbackRateLabel } = usePlayback();
  const { resolution, hasNativeHLS } = useResolution();
  const { registerItem } = useKeyboardInteractions();

  const { mediaType, transmissionType } = useApplicationData();
  const isLive = transmissionType === TRANSMISSION_TYPE.live;
  const isAudio = mediaType === MEDIA_TYPE.audio;

  return (
    <>
      {!hasNativeHLS && !isAudio && (
        <SettingOption
          {...registerItem({
            index: 0,
            keyActions: {
              [NAVIGATION_KEYS.ARROW_RIGHT]: () => push(MENU_ROUTES.RESOLUTION),
            },
          })}
          role='menuitem'
          aria-haspopup
          data-testid='settings-option-go-to-resolution'
          rightIcon={<ChevronRightIcon />}
          onClick={() => push(MENU_ROUTES.RESOLUTION)}
        >
          <SettingOptionLabel label={t('settings.quality')} value={resolution.label} />
        </SettingOption>
      )}
      {!isLive && (
        <SettingOption
          {...registerItem({
            index: 1,
            keyActions: {
              [NAVIGATION_KEYS.ARROW_RIGHT]: () => push(MENU_ROUTES.PLAYBACK_RATE),
            },
          })}
          role='menuitem'
          aria-haspopup
          data-testid='settings-option-go-to-playback-rate'
          rightIcon={<ChevronRightIcon />}
          onClick={() => push(MENU_ROUTES.PLAYBACK_RATE)}
        >
          <SettingOptionLabel label={t('settings.speed')} value={playbackRateLabel} />
        </SettingOption>
      )}
    </>
  );
};

export default HomeSettingControlContainer;
